import Swal from "sweetalert2";

export const maxData = (number) => {
  let aux,
    totalCeros = 0;

  for (let i = 1; ; i *= 10) {
    aux = number / i;
    totalCeros++;
    if (Math.round(aux) < 10) break;
  }

  totalCeros -= 1;

  const firstNumber = Math.floor(number / Math.pow(10, totalCeros));
  let result = firstNumber * Math.pow(10, totalCeros);
  const test = number - result;

  if (number > 10000) {
    if (test < 5000) {
      result += 10000;
    } else {
      if (number < 40000) {
        result += 15000;
      } else {
        result += 20000;
      }
    }
  } else {
    if (number < 1000) {
      if (number < 100) {
        result += 20;
      } else {
        result += 100;
      }
    } else {
      result += 1000;
    }
  }

  return result;
};

export const formatRole = (name) => {
  switch (name) {
    case "administrador":
      return "Administrador de la DIPRES";
    case "encargado_bgi":
      return "Encargado BGI";
    case "encargado":
      return "Encargado BGI";
    case "funcionario":
      return "Funcionario";
    case "jefe_servicio":
      return "Jefe de Servicio";
    case "representante":
      return "Representante Ministerial";
    case "representante_ministerial":
      return "Representante Ministerial";
    case "superadministrador":
      return "SuperAdministrador";
  }
};

export const possibleRoles = (idRol) => {
  switch (idRol) {
    case 1: {
      // SuperAdministrador
      return [2, 3, 4, 5, 6];
    }
    case 2: {
      // Administrador
      return [3, 4, 6];
    }
    case 3: {
      // Jefe de Servicio
      return [4, 5];
    }
    case 4: {
      // Encargado BGI
      return [3, 5];
    }
    case 5: {
      // Funcionario
      return [];
    }
    case 6: {
      // Representante Ministerial
      return [3, 4, 5];
    }
  }
};

export const hierarchyRole = (idRol) => {
  switch (idRol) {
    case 1:
      return [2, 3, 4, 5, 6];
    case 2:
      return [3, 4, 5, 6];
    case 3:
      return [4, 5];
    case 4:
      return [3, 5];
    case 5:
      return [];
    case 6:
      return [3, 4, 5];
  }
};


// # 1: superadministrador
// # 2: administrador
// # 3: jefe_servicio
// # 4: encargado_bgi
// # 5: funcionario
// # 6: representante_ministerial


export const hierarchyRoleEdit = (idRol) => {
  switch (idRol) {
    case 1:
      return [5];
    case 2:
      return [5];
    case 3:
    case 4:
      return [5];
    default:
      return [];
  }
};

export const formatPerm = (name) => {
  switch (name) {

    case "anexo2":
      return "Presentación de Servicio";
    case "anexo3":
      return "Resultado de la Gestion";
    case "anexo4":
      return "Desafios";
    case "anexo5":
      return "Recursos Humanos";
    case "anexo6":
      return "Recursos Financieros";
    case "anexo7":
      return "Indicadores";
    case "anexo8":
      return "Compromisos";
    case "anexo9":
      return "Evaluaciones";
    case "anexo10":
      return "Incentivo Institucional";
    case "anexo11":
      return "Incentivo Colectivo";
    case "anexo12":
      return "Equidad de Genero";
    case "anexo13":
      return "Leyes";
    case "anexo14":
      return "Premios y Reconocimientos";
    case "anexo15":
    return "Organigrama de Servicios";
    

    case "compromisos":
      return "Compromisos";
    case "desafios":
      return "Desafíos";
    case "equidad_genero":
      return "Equidad de Género";
    case "evaluaciones":
      return "Evaluaciones";
    case "incentivo_colectivo":
      return "Incentivo Colectivo";
    case "incentivo_institucional":
      return "Incentivo Institucional";
    case "indicadores":
      return "Indicadores";
    case "leyes":
      return "Leyes";
    case "organigrama_ministerio":
      return "Organigrama de Ministerio";
    case "organigrama_servicio":
      return "Organigrama de Servicio";
    case "premios_reconocimientos":
      return "Premios y Reconocimientos";
    case "presentacion_ministro":
      return "Presentación del Ministro";
    case "presentacion_servicio":
      return "Presentación del Servicio";
    case "recursos_financieros":
      return "Recursos Financieros";
    case "recursos_humanos":
      return "Recursos Humanos";
    case "resultados_gestion":
      return "Resultados de la Gestión";
  }
};

export const formatState = (state, apro) => {
  switch (state) {
    case "revisado_encargado_bgi":
      switch (apro) {
        case "aprobado":
          return "En revisión Jefe de Servicio";
        case "rechazado":
          return "En elaboración";
      }
      break;
    case "revisado_jefe_servicio":
      switch (apro) {
        case "aprobado":
          return "En revisión Representante Ministerial";
        case "rechazado":
          return "En elaboración";
      }
      break;
    case "revisado_representante_ministerial":
      switch (apro) {
        case "aprobado":
          return "En revisión Administrador";
        case "rechazado":
          return "En elaboración";
      }
      break;
    case "revisado_administrador":
      switch (apro) {
        case "aprobado":
          return "En revisión Super Administrador";
        case "rechazado":
          return "En elaboración";
      }
      break;
    case "finalizado":
      switch (apro) {
        case "aprobado":
          return "Proceso BGI Finalizado";
        case "rechazado":
          return "En elaboración";
      }
      break;
    // case "finalizado":
    //   return "Revisión Finalizada";
    // case "rechazado":
    //   return "En revisión Encargado BGI";
    default:
      return "En elaboración";
  }
};

export const showAlert = (data) => {
  Swal.fire(data);
};
